import React from 'react';
import ReactECharts from 'echarts-for-react';
import { chartColoursBlues } from '../../theme/constants';

const UnsubscribeFeedbackChart = ({ feedback, chartHeight = 350, padding = null }) => {
    const gridPadding = {
        left: padding,
        top: padding,
        right: padding,
        bottom: padding
    };

    const options = {
        dataset: {
            source: feedback
        },
        grid: {
            containLabel: true,
            ...padding && gridPadding
        },
        xAxis: {
            name: 'Submissions',
            type: 'value',
            nameLocation: 'center',
            nameGap: 25,
            minInterval: 1
        },
        yAxis: {
            name: 'Feedback',
            type: 'category',
            nameLocation: 'start',
            inverse: true
        },
        tooltip: {
            show: false
        },
        series: [
            {
                type: 'bar',
                encode: {
                    x: 'total',
                    y: 'feedback'
                },
                itemStyle: {
                    color: (params) => {
                        const index = params.dataIndex;
                        const colors = chartColoursBlues.map(e => e.value);

                        return colors[index % colors.length];
                    }
                },
                emphasis: {
                    disabled: true
                },
                cursor: 'default'
            }
        ]
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
        />
    );
};

export default UnsubscribeFeedbackChart;
